import fetchUtil from "./_fetchUtil";

export default class Http {
    private _fetch = new fetchUtil()
    private _baseUrl = `/api/files`


    patch = (fileId: string, options: any) => this._fetch.patch(`${this._baseUrl}/${fileId}`, options, true)

}